module.exports = {
	title: "ROC management portal",
	serverOptions: [
		{
			label: "Faulpelz-DEV",
			id: "dev",
			channel: "roc",
			docsVersion: "develop",
			hostname: "dev.faulpelz.io",
			accessCookieConfig: {
				name: "glient2idroc",
				path: "/glient2/roc",
				domain: ".dev.faulpelz.io",
			},
			refreshCookieConfig: {
				name: "refreshroc",
				path: "/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc",
				domain: ".dev.faulpelz.io",
			},
			glientWsUrl: "wss://api-mgmt.dev.faulpelz.io/glient2/roc",
			gupportWsUrl: "wss://api-mgmt.dev.faulpelz.io/gupport2/roc",
			ccWsUrl: "wss://api-mgmt.dev.faulpelz.io/cc2/roc",
			redirectUrl: "https://dev.faulpelz.io/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc/redirect",
			revokeUrl: "https://dev.faulpelz.io/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc/logout",
			invalidateTokenUrl: "https://dev.faulpelz.io/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc",
			editAccountUrl: "https://dev.faulpelz.io/api/profile/0e19a68ec8750be0bbf969a35937663b/redirect",
		},
		{
			label: "Faulpelz-PROD",
			id: "prod",
			channel: "roc",
			docsVersion: "develop",
			hostname: "prod.faulpelz.io",
			accessCookieConfig: {
				name: "glient2idroc",
				path: "/glient2/roc",
				domain: ".prod.faulpelz.io",
			},
			refreshCookieConfig: {
				name: "refreshroc",
				path: "/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc",
				domain: ".prod.faulpelz.io",
			},
			glientWsUrl: "wss://api-client.prod.faulpelz.io/glient2/roc",
			gupportWsUrl: "wss://api-mgmt.prod.faulpelz.io/gupport2/roc",
			ccWsUrl: "wss://api-mgmt.prod.faulpelz.io/cc2/roc",
			redirectUrl: "https://prod.faulpelz.io/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc/redirect",
			revokeUrl: "https://prod.faulpelz.io/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc/logout",
			invalidateTokenUrl: "https://prod.faulpelz.io/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc",
			editAccountUrl: "https://prod.faulpelz.io/api/profile/0e19a68ec8750be0bbf969a35937663b/redirect",
		},
		{
			label: "ROC-EU",
			id: "roc-eu",
			channel: "roc",
			docsVersion: "develop",
			hostname: "eu.roc-connect.com",
			accessCookieConfig: {
				name: "glient2idroc",
				path: "/glient2/roc",
				domain: ".eu.roc-connect.com",
			},
			refreshCookieConfig: {
				name: "refreshroc",
				path: "/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc",
				domain: ".eu.roc-connect.com",
			},
			glientWsUrl: "wss://api-client.eu.roc-connect.com/glient2/roc",
			gupportWsUrl: "wss://api-mgmt.eu.roc-connect.com/gupport2/roc",
			ccWsUrl: "wss://api-mgmt.eu.roc-connect.com/cc2/roc",
			redirectUrl: "https://eu.roc-connect.com/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc/redirect",
			revokeUrl: "https://eu.roc-connect.com/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc/logout",
			invalidateTokenUrl: "https://eu.roc-connect.com/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc",
			editAccountUrl: "https://eu.roc-connect.com/api/profile/0e19a68ec8750be0bbf969a35937663b/redirect",
		},
		{
			label: "ROC-US",
			id: "roc-us",
			channel: "roc",
			docsVersion: "public",
			hostname: "us.roc-connect.com",
			accessCookieConfig: {
				name: "glient2idroc",
				path: "/glient2/roc",
				domain: ".us.roc-connect.com",
			},
			refreshCookieConfig: {
				name: "refreshroc",
				path: "/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc",
				domain: ".us.roc-connect.com",
			},
			glientWsUrl: "wss://api-client.us.roc-connect.com/glient2/roc",
			gupportWsUrl: "wss://api-mgmt.us.roc-connect.com/gupport2/roc",
			ccWsUrl: "wss://api-mgmt.us.roc-connect.com/cc2/roc",
			redirectUrl: "https://us.roc-connect.com/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc/redirect",
			revokeUrl: "https://us.roc-connect.com/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc/logout",
			invalidateTokenUrl: "https://us.roc-connect.com/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc",
			editAccountUrl: "https://us.roc-connect.com/api/profile/0e19a68ec8750be0bbf969a35937663b/redirect",
		},
		{
			label: "Factory Leader",
			id: "factory-leader",
			visibleOnlyForOrigins: ["https://mgmt-factory.roc-connect.com"],
			channel: "core3admin",
			docsVersion: "develop",
			hostname: "api-mgmt.factoryleader.roc-connect.com",
			accessCookieConfig: {
				name: "gupport2core3admin",
				path: "/gupport2/core3admin",
				domain: ".factoryleader.roc-connect.com",
			},
			refreshCookieConfig: {
				name: "refreshcore3admin",
				path: "/api/oauth/e2fce322d00d0010b0cca18c14f3cefd/redirect/core3admin",
				domain: ".factoryleader.roc-connect.com",
			},
			gupportWsUrl: "wss://api-mgmt.factoryleader.roc-connect.com/gupport2/core3admin",
			ccWsUrl: "wss://api-mgmt.factoryleader.roc-connect.com/cc2/core3admin",
			redirectUrl: "https://factoryleader.roc-connect.com/api/oauth/e2fce322d00d0010b0cca18c14f3cefd/redirect/core3admin/redirect",
			revokeUrl: "https://factoryleader.roc-connect.com/api/oauth/e2fce322d00d0010b0cca18c14f3cefd/redirect/core3admin/logout",
			invalidateTokenUrl: "https://factoryleader.roc-connect.com/api/oauth/e2fce322d00d0010b0cca18c14f3cefd/redirect/core3admin",
			editAccountUrl: "https://factoryleader.roc-connect.com/api/profile/e2fce322d00d0010b0cca18c14f3cefd/redirect",
		},
	],
};
// {
// 	glientWsUrl: "wss://factoryleader.roc-connect.com/glient25/roc",
// 	gupportWsUrl: "wss://factoryleader.roc-connect.com/gupport2/roc",
// 	ccWsUrl: "wss://factoryleader.roc-connect.com/cc2/roc",
// 	redirectUrl: "https://factoryleader.roc-connect.com/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc/redirect",
// 	revokeUrl: "https://factoryleader.roc-connect.com/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc/logout",
// 	invalidateTokenUrl: "https://factoryleader.roc-connect.com/api/oauth/0e19a68ec8750be0bbf969a35937663b/redirect/roc",
// 	editAccountUrl: "https://factoryleader.roc-connect.com/api/profile/0e19a68ec8750be0bbf969a35937663b/redirect",
// }
